import { Directive, inject,
  Injector,
  Optional,
} from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {AnchorComponent} from "../../basic/anchor/anchor.component";
import { runtimeEventManager } from '@wm/core';

const DEFAULT_CLS = 'app-popover-wrapper';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-popover',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};
@Directive({
  selector: 'a[wmPopover]',
  providers: [
    provideAsWidgetRef(PopoverComponent)
  ],
  exportAs: 'wmPopover',
  standalone: true
})

export class PopoverComponent extends StylableComponent {
  static initializeProps = register('wm-popover');
  public anchor: AnchorComponent;
  inlinecontent: any;
  content: any;
  markupManager: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.anchor = inject(AnchorComponent);
    console.log(this.anchor);
    this.markupManager = runtimeEventManager.getService('markupManager');
  }

  override ngAfterViewInit(): void {
    let popover = this.markupManager?.getActiveMarkupEl()?.find('wm-popover[widgetid="' + this.$attrs.get("widgetid") + '"]');
    if(popover && popover.length) {
      let content = popover[0].innerHTML.trim();
      if(this.$attrs.get('contentsource') === 'inline' && content) {
        this.widgetProps['inlinecontent'].show = true;
        this.widgetProps['content'].show = false;
        this.inlinecontent = content;
      }
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any): void {
    switch (key) {
      case 'contentsource':
        //check for 2 option inline || partial
        if (this.$attrs.get('widgetid')) {
          if (nv === 'inline') {
            this.widgetProps['inlinecontent'].show = true;
            this.widgetProps['content'].show = false;
            this.widgetProps['onLoad'].show = false;
            this.content = '';
            this.widgetProps['content'].value = '';
          } else {
            this.widgetProps['onLoad'].show = true;
            this.widgetProps['content'].show = true;
            this.widgetProps['inlinecontent'].show = false;
          }
        }
        break;
      case'caption':
        this.anchor.caption = nv;
        break;
      case 'iconclass':
        this.anchor.iconclass = nv;
        break;
      case 'iconwidth':
        this.anchor.iconwidth = nv;
        break;
      case 'iconheight':
        this.anchor.iconheight = nv;
        break;
      case 'iconurl':
        this.anchor.iconurl = nv;
        break;
      case 'iconmargin':
        this.anchor.iconmargin = nv;
        break;
      case 'iconposition':
        $(this.nativeElement).attr('icon-position', nv);
        break;
      case 'class':
        if (ov) {
          const oldelements = ov?.split(' ');
          oldelements.forEach((element: any) => {
            this.nativeElement.classList.remove(element)
          });
        }
        if (nv) {
          const elements = nv.split(' ');
          elements.forEach((element: any) => {
            this.nativeElement.classList.add(element)
          });
        }
        break;
      case 'inlinecontent': 
        this.inlinecontent = nv;
        break;
      case 'badgevalue':
        this.anchor.badgevalue = nv;
        break;
      default: super.onPropertyChange(key, nv, ov);
    }
  }
}

